import { FormGroup, FormArray } from '@angular/forms';
import { IdexService } from 'app/idex.service';
import { BehaviorSubject } from 'rxjs';
export class EFormHelper {
   displayDisabledChanges: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
   displayDisabled: boolean = false;
    constructor() {
    }

    getSectionAsFormArray(Eform: FormGroup): FormArray {
        return Eform.controls.sections as FormArray;
    }

    getSectionAsFormGroup(Eform: FormGroup): FormGroup {
        return Eform.controls.sections as FormGroup;
    }

    getSectionAsFormGroupWithIndex(Eform: FormGroup, Index?: number): FormGroup {
        return this.getSectionAsFormArray(Eform).at(Index) as FormGroup;
    }

    getPermission(Eform: FormGroup, Index?: number): FormArray {
        return this.getSectionAsFormArray(Eform).at(Index)?.get('permissions') as FormArray;
    }

    getPermissionValue(Eform: FormGroup, Index?: number): FormGroup {
        return this.getSectionAsFormArray(Eform).at(Index)?.get('permissions').value as FormGroup;
    }

    getFieldAsFormArray(Eform: FormGroup, sectionIndex: number): FormArray {
        return this.getSectionAsFormArray(Eform).at(sectionIndex)?.get('fields') as FormArray;
    }

    getFieldAsFormGroupWithIndex(Eform: FormGroup, sectionIndex: number, fieldIndex: number): FormGroup {
        return this.getFieldAsFormArray(Eform, sectionIndex).at(fieldIndex) as FormGroup;
    }

    getFieldValue(Eform: FormGroup, sectionIndex: number, fieldIndex: number) {
        return this.getFieldAsFormArray(Eform, sectionIndex).at(fieldIndex)?.value;
    }

    getFieldSomeValue(Eform: FormGroup, value: string, sectionIndex: number, fieldIndex: number) {
        return this.getFieldAsFormArray(Eform, sectionIndex).at(fieldIndex)?.get(value).value;
    }

   getListconnecting (Eform: FormGroup, isCreated?: boolean) {
      const conntingLists = [];
      const sections = this.getSectionAsFormArray(Eform);
      for (let i = 0; i < sections.value.length; i++) {
         conntingLists.push(`new-field-${i}`);
         for (let j = 0; j < sections.at(i).get('fields').value.length; j ++) {
            conntingLists.push(`field-${i}-${j}`);
            // Add table column drop zones if field is a table
            const field = sections.at(i).get('fields').value[j];
            if (field && field.fieldType === 'f-table' && field.columns) {
               conntingLists.push(`fieldTableList-${i}-${j}`);
            }
         }
         if (isCreated) { conntingLists.push(`section-${i}`); }
      }
      return conntingLists;
   }

   getFieldTableAsFormArray(Eform: FormGroup, sectionIndex: number, fieldIndex: number): FormArray {
      return this.getFieldAsFormArray(Eform, sectionIndex).at(fieldIndex)?.get('columns') as FormArray;
   }

   getFieldTableAsFormGroupWithIndex(Eform: FormGroup, sectionIndex: number, fieldIndex: number, tableIndex: number): FormGroup {
      return this.getFieldTableAsFormArray(Eform, sectionIndex, fieldIndex)?.at(tableIndex) as FormGroup;
   }

   getFieldTableValue(Eform: FormGroup, sectionIndex: number, fieldIndex: number, tableIndex: number) {
      return this.getFieldTableAsFormArray(Eform, sectionIndex, fieldIndex)?.at(tableIndex)?.value;
   }

   getFieldTableSomeValue(Eform: FormGroup, value: string, sectionIndex: number, fieldIndex: number, tableIndex: number) {
      return this.getFieldTableAsFormArray(Eform, sectionIndex, fieldIndex)?.at(tableIndex)?.get(value)?.value;
   }

   checkDisplayDisabled(eForm, state, table?) {
      const _tmp = this.getFormGroup(table, state, eForm);
      this.displayDisabled = _tmp ? _tmp.get('display').value : false;
      this.displayDisabledChanges.next(this.displayDisabled);
      if (this.displayDisabled === false) {
         if (_tmp?.get('required') && _tmp?.get('required').value === true) {
            _tmp.get('required').setValue(this.displayDisabled);
            _tmp.get('required').disable();
         } else if (_tmp?.get('required') && _tmp?.get('required').value === false) {
            _tmp.get('required').disable();
         }
         _tmp?.markAsDirty();
         if (_tmp?.controls) {
            Object.keys(_tmp?.controls).forEach(key => {
               if (_tmp?.get(key).get('required')) {
                  if (_tmp?.get(key).get('required') && _tmp?.get(key).get('required').value === true) {
                     _tmp.get(key).get('required').setValue(this.displayDisabled);
                     _tmp.get(key).get('required').disable();
                  } else if (_tmp.get(key).get('required') && _tmp.get(key).get('required').value === false) {
                     _tmp.get(key).get('required').disable();
                  }
                  _tmp.get(key).markAsDirty();
               }
            });
         }

      } else if (this.displayDisabled === true) {
         _tmp.get('required')?.enable();
         _tmp.markAsDirty();
         Object.keys(_tmp?.controls).forEach(key2 => {
            if (_tmp?.get(key2).get('required')) {
               _tmp.get(key2).get('required')?.enable();
               _tmp.get(key2).markAsDirty();
            }
         });
      }
   }

   private getFormGroup(table: boolean, state: any, eForm: FormGroup): FormGroup {
      let fg = null;
      try {
         fg = table ? this.getFieldTableAsFormGroupWithIndex(eForm, state.sectionIndex, state.fieldIndex, state.tableIndex) : this.getFieldAsFormGroupWithIndex(eForm, state.sectionIndex, state.fieldIndex);
      } catch (error) {
         if (this.isField(state.name)) {
            fg = this.getFieldAsFormGroupWithIndex(eForm, state.sectionIndex, state.fieldIndex);
         } else {
            fg = this.getFieldTableAsFormGroupWithIndex(eForm, state.sectionIndex, state.fieldIndex, state.tableIndex);
         }
      }
      return fg;
   }

   isTableField(name: string): boolean {
      return name === 'table' || name?.startsWith('t-');
   }

   isField(name: string): boolean {
      return !this.isTableField(name) && name?.startsWith('f-');
   }
}
